import { useSelector } from 'react-redux';

const useFindInCart = (item) => {
  const convertedCart = useSelector((state) => state.allItemsCart.allItemsCart);
  return convertedCart?.find((items) => {
    return items?.sku === item?.sku
  })
}

export default useFindInCart